import React from 'react'

const TrashIcon = ({ fill = '#404040', ...props }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14.0471 3.48671C12.9738 3.38004 11.9004 3.30004 10.8204 3.24004V3.23337L10.6738 2.36671C10.5738 1.75337 10.4271 0.833374 8.8671 0.833374H7.12043C5.5671 0.833374 5.42043 1.71337 5.31376 2.36004L5.17376 3.21337C4.55376 3.25337 3.93376 3.29337 3.31376 3.35337L1.95376 3.48671C1.67376 3.51337 1.47376 3.76004 1.50043 4.03337C1.5271 4.30671 1.7671 4.50671 2.0471 4.48004L3.4071 4.34671C6.90043 4.00004 10.4204 4.13337 13.9538 4.48671C13.9738 4.48671 13.9871 4.48671 14.0071 4.48671C14.2604 4.48671 14.4804 4.29337 14.5071 4.03337C14.5271 3.76004 14.3271 3.51337 14.0471 3.48671Z'
        fill={fill}
      />
      <path
        d='M12.8202 5.42663C12.6602 5.25996 12.4402 5.16663 12.2135 5.16663H3.78683C3.56016 5.16663 3.33349 5.25996 3.18016 5.42663C3.02683 5.59329 2.94016 5.81996 2.95349 6.05329L3.36683 12.8933C3.44016 13.9066 3.53349 15.1733 5.86016 15.1733H10.1402C12.4668 15.1733 12.5602 13.9133 12.6335 12.8933L13.0468 6.05996C13.0602 5.81996 12.9735 5.59329 12.8202 5.42663ZM9.10682 11.8333H6.88683C6.61349 11.8333 6.38683 11.6066 6.38683 11.3333C6.38683 11.06 6.61349 10.8333 6.88683 10.8333H9.10682C9.38016 10.8333 9.60682 11.06 9.60682 11.3333C9.60682 11.6066 9.38016 11.8333 9.10682 11.8333ZM9.66683 9.16663H6.33349C6.06016 9.16663 5.83349 8.93996 5.83349 8.66663C5.83349 8.39329 6.06016 8.16663 6.33349 8.16663H9.66683C9.94016 8.16663 10.1668 8.39329 10.1668 8.66663C10.1668 8.93996 9.94016 9.16663 9.66683 9.16663Z'
        fill={fill}
      />
    </svg>
  )
}

export default TrashIcon
